import React, { useState, useEffect } from 'react';

const ServerInfoPage = () => {
  const [serverInfo, setServerInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServerInfo = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${baseUrl}/api/server-info`);
        if (!response.ok) throw new Error('Failed to fetch server info');
        const data = await response.json();
        setServerInfo(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchServerInfo();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8">
        <div className="text-center mb-6">
          <h1 className="text-xl font-bold text-gray-800">Server Information</h1>
          <p className="text-gray-500 mt-1">For Azure PostgreSQL Firewall Configuration</p>
        </div>

        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
            <p className="text-gray-500 mt-4">Detecting server IP...</p>
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
            <p className="font-medium">Error</p>
            <p className="text-sm">{error}</p>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-blue-600 font-medium mb-1">Outbound IP Address</p>
              <p className="text-2xl font-mono font-bold text-blue-800">{serverInfo?.outbound_ip || 'N/A'}</p>
            </div>
            
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <p className="text-sm text-gray-600 font-medium mb-1">Hostname</p>
              <p className="font-mono text-gray-800">{serverInfo?.hostname || 'N/A'}</p>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-sm text-yellow-800">
                <strong>Next Step:</strong> Add the IP address above to your Azure PostgreSQL firewall rules, then remove the "Allow_All_IPs" rule.
              </p>
            </div>

            <button
              onClick={() => navigator.clipboard.writeText(serverInfo?.outbound_ip || '')}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
            >
              Copy IP to Clipboard
            </button>
          </div>
        )}

        <div className="mt-6 pt-6 border-t border-gray-200 text-center">
          <a href="/" className="text-blue-600 hover:text-blue-800 text-sm">
            ← Back to Application
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServerInfoPage;
